import script from './component-lib.esm6.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "v-item"
  }, [_c('ListItem', _vm._g(_vm._b({
    staticClass: "v-item__list-item",
    attrs: {
      "role": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (props) {
        return [_vm._t("default", null, null, props)];
      }
    }], null, true)
  }, 'ListItem', Object.assign({}, _vm.$props, _vm.$attrs), false), _vm.$listeners)), _vm._v(" "), _vm._t("after")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-70feb9e8_0", {
    source: ".v-item[data-v-70feb9e8]{border:1px solid var(--g-color-gray-200);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min))}.v-item__list-item.v-item__list-item[data-v-70feb9e8]{border-radius:inherit}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-70feb9e8";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Item = __vue_component__;
export { Item as default };